import { render } from "./RestartButton.vue?vue&type=template&id=4046bcb8"
import script from "./RestartButton.vue?vue&type=script&lang=js"
export * from "./RestartButton.vue?vue&type=script&lang=js"

import "./RestartButton.vue?vue&type=style&index=0&id=4046bcb8&lang=scss"

import exportComponent from "/Users/silaskoehler/sublimes/bibelzentrum-herz-pwa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__